import api from "../axiosIntercepture";

export const fetchAdjustments = async (page = 0, pageSize = 10) => {
    try {
        const response = await api.post(
            "/adjustment/fetch-multi-dynamic",
            { page, limit: pageSize }
        );
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch adjustments";
    }
};

export const fetchAdjustmentById = async (adjustmentId) => {
    try {
        const response = await api.post(
            `/adjustment/fetch-multi-dynamic?id=${adjustmentId}`,
            {}
        );
        return response.data?.data?.data?.[0] || null;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch adjustment";
    }
};

export const createAdjustment = async (payload) => {
    try {
        const response = await api.post(
            "/adjustment/create-adjustment",
            payload,
            { headers: { "Content-Type": "application/json" } }
        );
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to create adjustment";
    }
};
